/**
 * Получает таймзону пользователя из браузера
 *
 * @returns {string} Таймзона пользователя в формате IANA (например, 'Asia/Omsk', 'Europe/Moscow')
 *                   В случае ошибки возвращает 'UTC'
 */
export const getUserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    // В случае ошибки возвращаем UTC как fallback
    return 'UTC';
  }
};
